import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderNaoLogado from "../../components/common/HeaderNaoLogado.js";
import DateTime from "../../components/Agendamento/Datetime.js";
import Especialista from "../../components/Agendamento/EspecialistaPicker.js";
import Especialidade from "../../components/Agendamento/Especialidade.js";
import PaymentPicker from "../../components/Agendamento/PaymentPicker.js";
import UserRegistration from "../../components/Agendamento/UserRegistration.js";
import InfoCliente from "../../components/Agendamento/infoCliente.js";

import { fetchColaboradores, updateComponent } from "../../store/modules/colaboradores/actions";
import  { getHorariosDisponiveis } from '../../store/modules/agendamento/actions.js'


function Agendar() {
    const dispatch = useDispatch()
    const { colaboradorId } = useParams(); // Pega o colaboradorId da URL

    const { colaboradores, components } = useSelector((state) => state.colaboradores);
    const { horariosDisponiveis } = useSelector((state) => state.agendamento);

    useEffect(() => {
        if (!colaboradores || colaboradores.length === 0) { // Verifica se colaboradores está vazio ou nulo
            dispatch(fetchColaboradores());
        }

        dispatch(getHorariosDisponiveis(colaboradorId))
    }, [colaboradores, dispatch]);
    
    const colaborador = colaboradores.find(c => c._id === colaboradorId);

    console.log(colaborador?.especialidades)

    console.log("horariosDisponiveis")
    console.log(horariosDisponiveis)
    return (
        <>
        <HeaderNaoLogado />
        <div style={{padding: "20px"}}>
            <Especialista nome={colaborador?.nome}  />
            <Especialidade servicos={colaborador?.especialidades}/>
            <DateTime datas={horariosDisponiveis} />
            <InfoCliente/>
            {/*<UserRegistration />*/}
            <PaymentPicker />
            <button style={{fontWeight: '600', marginTop: '10px', marginBottom: '10px'}}>Finalizar agendamento</button>
            {/* Aqui você pode buscar os detalhes do colaborador com esse ID ou exibir informações */}
        </div>
        </>
    );
}

export default Agendar;
